<template>
  <div class="view pa24">
    <el-form :model="serchParams" class="demo-form-inline" :inline="true">
      <el-row :gutter="24">
        <el-col :span="5" align="right">
          <el-form-item label="名称">
            <el-input
                v-model="serchParams.dealerName"
                class="mb10"
                style="width: 240px"
                placeholder="请输入分销商名称"
                clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="5" align="right">
          <el-form-item label="代号">
            <el-input
                v-model="serchParams.dealerCode"
                class="mb10"
                style="width: 240px"
                placeholder="请输入分销商代号"
                clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="5" align="right">
          <el-form-item label="手机号">
            <el-input
                v-model="serchParams.phone"
                class="mb10"
                style="width: 240px"
                placeholder="请输入手机号"
                clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="5" align="right">
          <el-form-item label="状态" class="ml10">
            <el-select v-model="serchParams.status" placeholder="请选择" clearable>
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="5" align="right">
          <el-form-item label="分销级别" class="ml10">
            <el-select v-model="serchParams.type" placeholder="请选择分销级别" clearable>
              <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5" align="right">
          <el-form-item label="上级名称">
            <el-input
                v-model="serchParams.parentName"
                class="mb10"
                placeholder="请输入上级名称"
                clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="5" align="right">
          <el-form-item label="上级代号">
            <el-input
                v-model="serchParams.parentCode"
                class="mb10"
                placeholder="请输入上级代号"
                clearable
            />
          </el-form-item>
        </el-col>
        <el-button class="ml10 mb10" type="primary" @click="getList">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-row>
    </el-form>
    <div style="width:100%;overflow-x: auto;overflow-y: hidden;">
      <commonTable :tableData="tableData" :total="total" :currentPage="pageNum" @handleSizeChange="handleSizeChange"
                   @handleCurrentChange="handleCurrentChange" @selectFun="selcetFun" :rowClassName="delRowClassName">
        <template v-slot:table>
          <el-table-column
              type="selection"
              width="55"
              :selectable="row => !row.isDel">
          </el-table-column>
          <el-table-column prop="dealerName" align="center" label="代理商名称" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.dealerName }}</span>
              <el-tag v-if="scope.row.isDirectSale === true" size="mini" type="success">直营店</el-tag>
              <span v-if="scope.row.isDel" class="del-mark">已删除</span>
            </template>
          </el-table-column>
          <el-table-column prop="code" align="center" label="代号" width="180">
            <template slot-scope="scope">
              {{ scope.row.code || '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="liaison" align="center" label="联系人" width="100">
            <template slot-scope="scope">
              {{ scope.row.liaison || '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="phone" align="center" label="手机号" width="120">
            <template slot-scope="scope">
              {{ scope.row.phone || '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="phone" align="center" label="上级分销商" width="180">
            <template slot-scope="scope" v-if="scope.row.type==2">
              {{ scope.row.parentCode || '--' }}|{{ scope.row.parentName || '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="leader" align="center" label="项目负责人">
            <template slot-scope="scope">
              {{ scope.row.leader || '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="salesman" align="center" label="业务员">
            <template slot-scope="scope">
              {{ scope.row.salesman || '--' }}
            </template>
          </el-table-column>
          <el-table-column align="center"  label="代理商地址">
            <template slot-scope="scope" v-if="scope.row.addressList">
              <div v-for="(item,index) in scope.row.addressList.slice(0,scope.row.displayCount)" :key="index">
                {{ item }}
              </div>
              <el-button
                  type="text"
                  :class="[scope.row.addressList && scope.row.addressList.length <= hiddenNum1 ? 'hideBtn' : '']"
                  @click="scope.row.displayCount > hiddenNum1 ? hideList1(scope.row) : viewAll1(scope.row)">
                {{ scope.row.displayCount > hiddenNum1 ? '收起' : '•••查看更多' }}
              </el-button>
            </template>
            <template slot-scope="scope" v-else>
              {{ scope.row.address || '--' }}
            </template>
          </el-table-column>
          <el-table-column align="center" width="200" label="销售区域">
            <template slot-scope="scope" v-if="scope.row.area">
              <div v-for="item in scope.row.area.slice(0,scope.row.displayCount)" :key="item.id">
                {{ item.address }}
              </div>
              <el-button
                  type="text"
                  :class="[scope.row.area && scope.row.area.length <= hiddenNum ? 'hideBtn' : '']"
                  @click="scope.row.displayCount > hiddenNum ? hideList(scope.row) : viewAll(scope.row)">
                {{ scope.row.displayCount > hiddenNum ? '收起' : '•••查看更多' }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" width="100" label="营业执照">
            <template slot-scope="scope" v-if="scope.row.license">
              <el-image
                  style="width: 80px; height: 80px"
                  :preview-src-list="[ossUrl+scope.row.license]"
                  :src="ossUrl+scope.row.license"
                  fit="scale-down"></el-image>
            </template>
          </el-table-column>
        </template>
      </commonTable>
    </div>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import {queryPageAllDealer, fetchDeleteDeal, exportDealer} from '@/api/companyManage.js'
import {checkPermission} from "@/directives/permission";

export default {
  name: "dealerList",
  components: {
    commonTable,
  },
  data() {
    return {
      ossUrl: this.$store.state.ossUrl,
      drawer: false,
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      serchParams: {
        dealerName: '',
        enabled: '',
        phone: '',
        type: '',
        parentName: '',
        status: '',
        dealerCode:'',
        parentCode:''
      },
      options: [
        {value: 0, label: '待审批'},
        {value: 1, label: '正常'},
        {value: 2, label: '拉黑'},
        {value: 3, label: '驳回'},
      ],
      typeOptions: [
        {value: 1, label: '一级分销商'},
        {value: 2, label: '二级分销商'},
      ],
      hiddenNum: 5,
      hiddenNum1: 5,
      exportLoadding: false,
      dealerOptions: [],
      toggleList: [],
      dialogFormVisible: false,
      auditForm: {
        result: true,
        reason: '',
        ids: []
      },
      auditRules: {
        reason: [
          {required: true, message: '请输入备注', trigger: 'blur'}
        ]
      },
    };
  },
  created() {
    this.getList()
  },
  methods: {
    checkPermission,
    delRowClassName({row}) {
      if (row.isDel) return 'row-del'
      return ''
    },
    selcetFun(arr) {
      this.toggleList = arr
    },
    toAudit() {
      if (this.toggleList.length <= 0) {
        this.$message.error('请选择要操作的分销商')
        return
      }
      const unapprovedList = this.toggleList.filter(item => item.status !== 0);
      if (unapprovedList.length > 0) {
        // 提取未通过审核的分销商名称并拼接成字符串
        const unapprovedNames = unapprovedList.map(item => item.dealerName).join('、');
        this.$message.error(`选择的分销商中存在已审核通过的：${unapprovedNames}，请重新选择!`);
        return;
      }
      const approvedIds = this.toggleList.map(item => item.id);
      this.auditForm.ids = approvedIds
      this.dialogFormVisible = true
    },
    resetSearch() {
      this.serchParams.dealerName = ''
      this.serchParams.enabled = ''
      this.serchParams.phone = ''
      this.serchParams.parentId = ''
      this.serchParams.type = ''
      this.serchParams.status = ''
      this.serchParams.dealerCode = ''
      this.serchParams.parentCode = ''
      this.serchParams.parentName = ''
      this.pageNum = 1
      this.getList()
    },
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getList();
    },
    handleAddDealer(type, id) {
      this.$refs.addDealerDialog.openDialog(type, id, 'daili')
    },
    getList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        companyId: JSON.parse(localStorage.getItem('info')).companyId,
        isJk:true,
        isDel:true
      }
      Object.assign(params, this.serchParams)
      queryPageAllDealer(params).then(res => {
        res.data.list.forEach(item => {
          item.displayCount = this.hiddenNum
          if (item.address) {
            item.addressList = item.address.split(',').map(str => "•" + str)
          }
        })
        this.tableData = res.data.list
        this.total = res.data.total
      })
    },
    editDealar(data) {
      this.$refs.addDealerDialog.openDialog('edit', data, 'daili')
    },
    deleteDealar(data) {
      let params = {
        id: data.id
      }
      this.$confirm('此操作将永久删除该代理商, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        fetchDeleteDeal(JSON.stringify(params)).then(res => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.getList()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    viewAll(row) {
      row.displayCount = row.area.length;
    },
    // 收起多出部分时，只取前5条
    hideList(row) {
      row.displayCount = this.hiddenNum;
    },
    viewAll1(row) {
      row.displayCount = row.addressList.length;
    },
    // 收起多出部分时，只取前5条
    hideList1(row) {
      row.displayCount = this.hiddenNum1;
    },
    importDealer() {
      this.$refs.importDealerDialog.openDialog()
    },
    exportDealer() {
      this.exportLoadding = true
      let params = {
        companyId: JSON.parse(localStorage.getItem('info')).companyId,
      }
      Object.assign(params, this.serchParams)
      exportDealer(params).then(result => {
        this.exportLoadding = false
        const url = window.URL.createObjectURL(result.data);
        const temp = result.fileName.split(";")[1].split("filename=")[1];
        const fileName = decodeURIComponent(temp)
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      }).catch(err => {
        this.exportLoadding = false
        this.$message.error(err.message)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.hideBtn {
  display: none;
}
.del-mark {
  display: inline-block;
  margin-left: 4px;
  padding: 0 4px;
  font-size: 10px;
  line-height: 16px;
  color: #fff;
  background: #F56C6C;
  border-radius: 2px;
  vertical-align: middle;
}
::v-deep .row-del {
  td {
    color: #999 !important;
    text-decoration: line-through;
  }
}
</style>